import React from "react";
import { Link } from "react-router";
import glamorous, { Div, Footer, Span, Ul } from "glamorous";
import { dimensions, textColor, color } from "../../style/index";
import { SOCIAL_LINKS } from '../../config/Master';
import Container from './Container';

const youtube = fillColor => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Symbols" fill="none" fillRule="evenodd">
        <g id="Social/YouTube" transform="translate(0 -1)" fill={fillColor}>
          <g id="Group-14" transform="translate(0 .42)">
            <path
              d="M13.2447,1.4517 C10.0827,1.4517 7.1087,2.6827 4.8747,4.9187 C0.2577,9.5347 0.2577,17.0467 4.8717,21.6637 C7.1067,23.8987 10.0797,25.1297 13.2427,25.1297 C16.4067,25.1297 19.3797,23.8967 21.6177,21.6607 C26.2317,17.0447 26.2317,9.5337 21.6147,4.9187 C19.3797,2.6827 16.4067,1.4517 13.2447,1.4517 M13.2427,25.9997 C9.8467,25.9997 6.6547,24.6797 4.2567,22.2787 C-0.6993,17.3217 -0.6963,9.2587 4.2587,4.3027 C6.6597,1.9027 9.8507,0.5807 13.2447,0.5807 C16.6407,0.5807 19.8317,1.9027 22.2307,4.3027 C27.1857,9.2577 27.1857,17.3207 22.2327,22.2767 C19.8317,24.6787 16.6387,25.9997 13.2427,25.9997"
              id="Fill-12"
            />
            <path
              d="M11.4766399,15.4641585 L11.4766399,9.74569637 L16.1003744,12.6054274 L11.4766399,15.4641585 Z M21.1900005,9.8516864 C21.1900005,8.59780435 20.1078953,7.5809 18.7709889,7.5809 L7.41901167,7.5809 C6.08210526,7.5809 5,8.59780435 5,9.8516864 L5,15.9401137 C5,17.1929959 6.08210526,18.2109001 7.41901167,18.2109001 L18.7709889,18.2109001 C20.1078953,18.2109001 21.1900005,17.1929959 21.1900005,15.9401137 L21.1900005,9.8516864 Z"
              id="Fill-21"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const twitter = (fillColor) => {
  return (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g
        id="Social/Twitter"
        transform="translate(0 -1)"
        fill={fillColor}
      >
        <g id="Group" transform="translate(0 1)">
          <path
            d="M13.3418,0.8708 C10.1798,0.8708 7.2068,2.1018 4.9718,4.3378 C0.3548,8.9538 0.3548,16.4658 4.9688,21.0828 C7.2048,23.3178 10.1768,24.5488 13.3398,24.5488 C16.5048,24.5488 19.4768,23.3158 21.7148,21.0798 C26.3288,16.4638 26.3288,8.9528 21.7128,4.3378 C19.4768,2.1018 16.5048,0.8708 13.3418,0.8708 M13.3398,25.4188 C9.9438,25.4188 6.7528,24.0988 4.3538,21.6978 C-0.6022,16.7408 -0.5992,8.6778 4.3558,3.7218 C6.7568,1.3218 9.9478,-0.0002 13.3418,-0.0002 C16.7378,-0.0002 19.9288,1.3218 22.3278,3.7218 C27.2838,8.6768 27.2838,16.7398 22.3298,21.6958 C19.9288,24.0978 16.7358,25.4188 13.3398,25.4188"
            id="Fill-9"
          />
          <path
            d="M21.689,8.509 C21.112,8.765 20.491,8.939 19.84,9.016 C20.505,8.617 21.015,7.988 21.256,7.236 C20.634,7.605 19.945,7.872 19.212,8.016 C18.625,7.391 17.788,7 16.862,7 C15.085,7 13.643,8.442 13.643,10.219 C13.643,10.471 13.671,10.717 13.727,10.952 C11.052,10.819 8.68,9.536 7.092,7.589 C6.815,8.064 6.656,8.617 6.656,9.207 C6.656,10.323 7.225,11.309 8.088,11.887 C7.561,11.869 7.064,11.725 6.63,11.484 C6.63,11.497 6.63,11.511 6.63,11.525 C6.63,13.084 7.74,14.384 9.212,14.68 C8.942,14.754 8.658,14.793 8.364,14.793 C8.156,14.793 7.955,14.773 7.759,14.736 C8.168,16.014 9.356,16.945 10.766,16.971 C9.664,17.834 8.276,18.349 6.768,18.349 C6.508,18.349 6.251,18.334 6,18.304 C7.424,19.217 9.116,19.75 10.934,19.75 C16.855,19.75 20.092,14.846 20.092,10.592 C20.092,10.452 20.089,10.314 20.083,10.175 C20.712,9.722 21.257,9.155 21.689,8.509"
            id="Fill-7"
          />
        </g>
      </g>
    </g>
  </svg>
)};

const instagram = (fillColor) => {
  return (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g
        id="Social/Instagram"
        transform="translate(0 -1)"
        fill={fillColor}
      >
        <g id="Group-17" transform="translate(0 .42)">
          <path
            d="M13.4522,1.4517 C10.2902,1.4517 7.3172,2.6827 5.0822,4.9187 C0.4652,9.5347 0.4652,17.0467 5.0792,21.6637 C7.3152,23.8987 10.2872,25.1297 13.4502,25.1297 C16.6152,25.1297 19.5882,23.8967 21.8252,21.6607 C26.4392,17.0447 26.4392,9.5337 21.8232,4.9187 C19.5882,2.6827 16.6152,1.4517 13.4522,1.4517 M13.4502,25.9997 C10.0542,25.9997 6.8632,24.6797 4.4642,22.2787 C-0.4918,17.3217 -0.4888,9.2587 4.4662,4.3027 C6.8672,1.9027 10.0582,0.5807 13.4522,0.5807 C16.8482,0.5807 20.0392,1.9027 22.4382,4.3027 C27.3942,9.2577 27.3942,17.3207 22.4412,22.2767 C20.0392,24.6787 16.8462,25.9997 13.4502,25.9997"
            id="Fill-15"
          />
          <path
            d="M18.0627567,9.71005272 C18.0617567,10.1530527 17.7007567,10.5130527 17.2567567,10.5110527 C16.8127567,10.5100527 16.4547567,10.1490527 16.4557567,9.70605272 C16.4567567,9.26205272 16.8167567,8.90305272 17.2607567,8.90405272 C17.7047567,8.90505272 18.0627567,9.26605272 18.0627567,9.71005272 M13.6697567,15.4880527 C12.4437567,15.4780527 11.4597567,14.4750527 11.4707567,13.2490527 C11.4817567,12.0230527 12.4847567,11.0390527 13.7097567,11.0500527 C14.9357567,11.0610527 15.9197567,12.0640527 15.9087567,13.2890527 C15.8977567,14.5150527 14.8957567,15.4990527 13.6697567,15.4880527 M13.6937567,9.84005272 C11.7977567,9.83905272 10.2607567,11.3740527 10.2597567,13.2700527 C10.2587567,15.1650527 11.7937567,16.7020527 13.6897567,16.7030527 C15.5847567,16.7040527 17.1227567,15.1680527 17.1237567,13.2730527 C17.1247567,11.3780527 15.5887567,9.84105272 13.6937567,9.84005272 M19.0437567,16.6250527 C18.8647567,17.7940527 18.0887567,18.5190527 16.9137567,18.6470527 C15.8337567,18.7650527 11.0127567,18.8300527 10.0107567,18.5500527 C9.05375668,18.2820527 8.50575668,17.6240527 8.34675668,16.6590527 C8.19475668,15.7380527 8.15675668,11.1370527 8.34475668,9.90505272 C8.52075668,8.74605272 9.29675668,8.02305272 10.4657567,7.89305272 C11.6507567,7.76005272 15.9177567,7.74505272 17.0537567,7.91905272 C18.2197567,8.09805272 18.9427567,8.87605272 19.0707567,10.0530527 C19.1907567,11.1510527 19.2247567,15.4440527 19.0437567,16.6250527 M20.2757567,9.93805272 C20.1857567,9.05705272 19.8487567,8.27705272 19.1937567,7.65305272 C18.5047567,6.99605272 17.6627567,6.70605272 16.7397567,6.65605272 C15.1667567,6.57005272 11.4317567,6.51705272 10.1197567,6.73105272 C8.62075668,6.97505272 7.63875668,7.85005272 7.22475668,9.33005272 C6.90475668,10.4690527 6.96875668,15.7170527 7.15475668,16.8430527 C7.40875668,18.3820527 8.31775668,19.3690527 9.84375668,19.7620527 C10.8997567,20.0340527 16.0877567,19.9990527 17.2517567,19.8110527 C18.7927567,19.5620527 19.7837567,18.6570527 20.1837567,17.1350527 C20.4897567,15.9660527 20.3827567,10.9920527 20.2757567,9.93805272"
            id="Fill-3"
          />
        </g>
      </g>
    </g>
  </svg>
)};

const facebook = (fillColor) => {
  return (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g id="Social/FB" transform="translate(0 -1)" fill={fillColor}>
        <g id="Group-20" transform="translate(0 .42)">
          <path
            d="M12.7041,1.4517 C9.5411,1.4517 6.5691,2.6827 4.3331,4.9187 C-0.2829,9.5347 -0.2829,17.0467 4.3311,21.6637 C6.5661,23.8987 9.5391,25.1297 12.7021,25.1297 C15.8661,25.1297 18.8391,23.8967 21.0771,21.6607 C25.6911,17.0447 25.6911,9.5337 21.0741,4.9187 C18.8391,2.6827 15.8661,1.4517 12.7041,1.4517 M12.7021,25.9997 C9.3061,25.9997 6.1151,24.6797 3.7161,22.2787 C-1.2399,17.3217 -1.2379,9.2587 3.7181,4.3027 C6.1191,1.9027 9.3101,0.5807 12.7041,0.5807 C16.1001,0.5807 19.2911,1.9027 21.6901,4.3027 C26.6461,9.2577 26.6461,17.3207 21.6921,22.2767 C19.2911,24.6787 16.0981,25.9997 12.7021,25.9997"
            id="Fill-18"
          />
          <path
            d="M15.638,13.0179 L13.555,13.0179 L13.555,20.4449 L10.468,20.4449 L10.468,13.0179 L9,13.0179 L9,10.3949 L10.468,10.3949 L10.468,8.6969 C10.468,7.4829 11.045,5.5809 13.583,5.5809 L15.87,5.5909 L15.87,8.1379 L14.211,8.1379 C13.938,8.1379 13.555,8.2739 13.555,8.8529 L13.555,10.3969 L15.908,10.3969 L15.638,13.0179 Z"
            id="Fill-1"
          />
        </g>
      </g>
    </g>
  </svg>
)};

const MTLogo = (fillColor) => {
  return (
  <svg
    width="82"
    height="86"
    viewBox="0 0 82 86"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" fill="none" fillRule="evenodd">
      <g id="Footer" transform="translate(-559 -32)" fill={fillColor}>
        <g transform="translate(559 32)" id="Logo/Wordblock">
          <g id="MT">
            <path
              d="M48.5992741,58.5171479 L48.5992741,57.9685799 L50.2539531,57.9685799 L50.2534469,34.8702012 L47.541879,34.8702012 C45.9155457,35.6248639 44.8009531,37.0934793 44.1986074,39.2770651 C43.8913605,40.3747101 43.7491259,41.3975503 43.7719037,42.3466036 L42.8339654,42.3466036 L43.6013235,34.322142 L59.7543111,34.322142 L60.5221753,42.3466036 L59.5837309,42.3466036 C59.5948667,41.3975503 59.4526321,40.3747101 59.1570272,39.2770651 C58.5541753,37.0934793 57.4400889,35.6248639 55.8142617,34.8702012 L53.1021877,34.8702012 L53.1021877,57.9685799 L54.7396568,57.9685799 L54.7396568,58.5171479 L48.5992741,58.5171479 Z"
              id="Fill-1"
            />
            <polygon
              id="Fill-3"
              points="40.7711593 34.3219385 40.7711593 34.8699976 39.2015173 34.8699976 39.2015173 57.9683763 40.7711593 57.9683763 40.7711593 58.5169444 34.6991099 58.5169444 34.6991099 57.9683763 36.3532827 57.9683763 36.3532827 36.1564355 30.5201469 58.3118675 29.9911963 58.3286604 23.4924432 36.482116 23.4924432 57.9683763 25.4032457 57.9683763 25.4032457 58.5169444 21.0192827 58.5169444 21.0192827 57.9683763 22.929579 57.9683763 22.929579 34.8699976 21.0192827 34.8699976 21.0192827 34.3219385 25.7778136 34.3219385 31.3219247 53.1325302 36.2682457 34.3219385"
            />
            <path
              d="M40.7706531,20.4187917 L43.5839617,24.5569692 L46.3972704,28.6951467 C46.3972704,28.6951467 42.2765173,25.8769929 40.7706531,25.8769929 C39.2647889,25.8769929 35.1440358,28.6951467 35.1440358,28.6951467 L37.9573444,24.5569692 L40.7706531,20.4187917 Z"
              id="Fill-5"
            />
            <polygon
              id="Fill-7"
              points="6.87018272 16.6606426 6.98103457 16.7390095 6.75730617 17.0575657 11.3999235 20.3515183 11.6231457 20.0324533 11.7334914 20.1108201 10.8679358 21.3448438 10.757084 21.265968 10.9934667 20.9301101 6.6095037 17.8198615 10.230158 22.1636249 10.1587877 22.273542 4.8409358 20.4787373 9.15960247 23.5421692 9.43192346 23.1544059 9.54226914 23.2327728 8.91714568 24.1233053 8.80730617 24.0454473 9.07962716 23.6571751 4.43700988 20.3632225 4.16418272 20.7514947 4.05434321 20.6731278 4.73261481 19.7062639 9.3043679 21.2624059 6.22835556 17.5756012"
            />
            <polygon
              id="Fill-9"
              points="11.3564938 11.7584899 11.4496296 11.856703 11.1444074 12.1493065 15.0652222 16.2839219 15.3704444 15.9913183 15.4630741 16.0895314 14.3429136 17.163768 14.2497778 17.0650462 14.555 16.7729515 10.6346914 12.6378272 10.328963 12.9304308 10.2358272 12.8322178"
            />
            <path
              d="M17.7118481,10.4845704 C16.9328481,10.5023811 16.3694778,10.2479432 16.0207247,9.72074793 C15.7727,9.34672426 15.7033543,8.94776568 15.8121815,8.52539882 C15.9280951,8.07809704 16.2247123,7.69440473 16.7025395,7.37483077 C16.8473049,7.2776355 16.9946012,7.20893728 17.1424037,7.16670059 L17.7715765,6.74636923 L19.0192926,8.29538698 L18.8264407,8.42464142 C18.6588975,8.19717396 18.434663,7.9783574 18.1542432,7.76870059 C17.5928975,7.34989586 17.0978605,7.28323314 16.6696383,7.57023905 C16.3370827,7.79261775 16.1584037,8.05316213 16.1330951,8.35187219 C16.1143667,8.57425089 16.1801691,8.79764734 16.3279716,9.02104379 C16.4636259,9.22561183 16.6741938,9.38590769 16.9596753,9.50040473 C17.2061815,9.60370651 17.4425642,9.65103195 17.6667988,9.64339882 L18.2281444,9.62558817 L18.2413049,9.61591953 L18.7049593,9.61133964 C19.439416,9.52737515 20.0032926,9.78181302 20.3960827,10.3751621 C20.6430951,10.7491858 20.7129469,11.1481444 20.6046259,11.5705112 C20.4882062,12.0183219 20.1915889,12.4015053 19.7142679,12.7215882 C19.5684901,12.8182746 19.4217,12.8874817 19.2738975,12.9292095 L18.6452309,13.3495408 L17.3995395,11.8040852 L17.5923914,11.6748308 C17.758416,11.8997538 17.9816383,12.1170438 18.2625642,12.3272095 C18.8234037,12.7460142 19.3184407,12.812168 19.7471691,12.5261799 C20.0792185,12.3032923 20.2584037,12.0432568 20.2837123,11.7440379 C20.3019346,11.5216592 20.2361321,11.2982627 20.0883296,11.0748663 C19.9531815,10.8702982 19.7522309,10.7130556 19.485984,10.6041562 C19.219737,10.4952568 18.9742432,10.4448781 18.7495025,10.4530201 L17.7118481,10.4845704 Z"
              id="Fill-11"
            />
            <path
              d="M24.4539691,6.60932899 C23.6866111,6.47600355 23.182463,6.11673728 22.9415247,5.53153018 C22.7709444,5.1157787 22.778537,4.71173136 22.9668333,4.31837041 C23.1672778,3.90160118 23.5317222,3.58304497 24.0616852,3.3621929 C24.2226481,3.2950213 24.3800679,3.25583787 24.5334383,3.24413373 L25.2309444,2.95356568 L26.1577469,4.71580237 L25.9431296,4.8053645 C25.8231667,4.5494 25.6449938,4.29089112 25.4101296,4.0313645 C24.9404012,3.51078462 24.4676358,3.34997988 23.9918333,3.54742367 C23.6223272,3.70110414 23.3970802,3.92195621 23.3150802,4.20997988 C23.2543395,4.42523432 23.2755988,4.65677278 23.3773395,4.90459527 C23.4714877,5.13206272 23.6466235,5.32950651 23.9052778,5.4974355 C24.1274877,5.64653609 24.3491914,5.73915148 24.5714012,5.77528166 L25.1246481,5.86637041 L25.1403395,5.85975503 L25.5964012,5.94575503 C26.3328827,6.00631124 26.8370309,6.36557751 27.1083395,7.02355385 C27.2799321,7.43930533 27.270821,7.84335266 27.0830309,8.23671361 C26.8835988,8.65399172 26.518142,8.97254793 25.988179,9.19289112 C25.8267099,9.26006272 25.6692901,9.29924615 25.5169321,9.31145917 L24.8189198,9.60151834 L23.894142,7.84335266 L24.1077469,7.75429941 C24.2277099,8.00721065 24.4048704,8.26368402 24.6397346,8.5242284 C25.1099691,9.04429941 25.5827346,9.20612189 26.0580309,9.00766036 C26.4270309,8.85448876 26.6522778,8.63363669 26.734784,8.34510414 C26.7955247,8.13035858 26.7747716,7.89882012 26.6725247,7.65048876 C26.5788827,7.42353018 26.4118457,7.23066627 26.1714136,7.07189704 C25.9314877,6.91312781 25.7001667,6.81593254 25.4779568,6.77980237 L24.4539691,6.60932899 Z"
              id="Fill-13"
            />
            <path
              d="M37.3060012,6.13973846 L37.2979025,6.00437751 L37.706384,5.97995148 L37.3642111,0.277489941 L36.6950506,0.318708876 C36.3042852,0.528874556 36.0511988,0.908495858 35.934779,1.45655503 C35.8750506,1.7318568 35.855816,1.98680355 35.8745444,2.22037751 L35.6432235,2.23462604 L35.7135815,0.241868639 L39.7012111,0.000152662722 L40.0099765,1.96950178 L39.7781494,1.9837503 C39.7670136,1.74915858 39.7169025,1.49879172 39.627816,1.23214083 C39.4466062,0.702401183 39.1499889,0.35636568 38.737458,0.194543195 L38.0672852,0.234744379 L38.4099642,5.93720592 L38.8138901,5.91277988 L38.8219889,6.04814083 L37.3060012,6.13973846 Z"
              id="Fill-15"
            />
            <path
              d="M46.1492457,0.45412071 L45.6947025,3.25853491 L46.4068877,3.37557633 C46.8340975,3.44529231 47.1438753,3.39745799 47.3357148,3.2315645 C47.5310975,3.06261775 47.6718136,2.71352899 47.7583691,2.18328047 L47.7669741,2.12883077 C47.9152827,1.21387219 47.6222086,0.695836686 46.8872457,0.575233136 L46.1492457,0.45412071 Z M45.6005543,6.28990769 L44.1139247,6.04564734 L44.135184,5.91181302 L44.5391099,5.97796686 L45.4542704,0.340132544 L45.0503444,0.273978698 L45.0721099,0.140144379 L47.1742457,0.48516213 C48.1845667,0.650546746 48.6259494,1.13092544 48.4963691,1.92629822 L48.3850111,2.6127716 C48.3217395,3.00358817 48.1810235,3.27532781 47.9623568,3.42849941 C47.775579,3.55826272 47.5017395,3.61474793 47.1393198,3.59897278 C47.4632704,3.74654675 47.6895296,3.95111479 47.8175914,4.21267692 C47.9324926,4.44930414 47.9669123,4.71697278 47.9188259,5.01568284 L47.7371099,6.13317396 C47.6920605,6.40949349 47.7487519,6.56062959 47.907184,6.58658225 C48.0706778,6.61355266 48.173937,6.49549349 48.2164556,6.23291361 L48.2260728,6.1743929 L48.3470481,6.19423905 L48.3369247,6.25326864 C48.3025049,6.46546982 48.2326531,6.60999053 48.1258506,6.68683077 C48.0291716,6.75400237 47.8859247,6.77181302 47.6945914,6.7407716 C47.4415049,6.69904379 47.2739617,6.59879527 47.1914556,6.43900828 C47.1140111,6.28583669 47.101863,6.04564734 47.1545049,5.71996686 L47.2218259,5.30523314 C47.3114185,4.75259408 47.2481469,4.31852308 47.0315049,4.00200237 C46.8305543,3.71092544 46.5071099,3.5292568 46.0596531,3.4559787 L45.6724309,3.39236923 L45.2345914,6.09246391 L45.6218136,6.1555645 L45.6005543,6.28990769 Z"
              id="Fill-17"
            />
            <path
              d="M53.3520346,5.99933964 L55.0492321,6.66596686 L55.4597383,3.07075976 L53.3520346,5.99933964 Z M56.1643309,2.88807337 L55.4815037,8.89840473 L55.8621457,9.04852308 L55.8130469,9.17472426 L54.410442,8.62361183 L54.4595407,8.49690178 L54.8249975,8.64091361 L55.0355654,6.80590769 L53.2675037,6.11180118 L52.1923926,7.60636923 L52.6519975,7.78702012 L52.6034049,7.9132213 L51.5935901,7.51629822 L51.6426889,7.39009704 L52.0633185,7.55497278 L55.5872938,2.66111479 L56.1643309,2.88807337 Z"
              id="Fill-19"
            />
            <polygon
              id="Fill-21"
              points="65.6015185 7.92278817 65.5281235 8.03677633 65.1495062 7.7899716 60.7194815 11.8726817 60.1991358 11.5337704 62.0694444 5.78398343 61.7262593 5.56007811 61.7991481 5.44608994 63.0635679 6.26945089 62.9896667 6.38343905 62.6611605 6.16920237 60.9285309 11.4935692 65.0330864 7.71364024 64.6185309 7.44444497 64.6919259 7.32994793"
            />
            <path
              d="M67.1899901,16.9680036 C67.4182741,17.0545124 67.6607309,17.072832 67.9173605,17.023471 C68.1228667,16.9858142 68.3309037,16.9059207 68.5445086,16.7848083 C68.7864593,16.6494473 68.9889284,16.4967846 69.1509037,16.327329 L69.3138914,16.4922047 L67.7847432,17.760832 L65.2397062,15.1920272 L65.3353728,15.0963586 L65.6238914,15.3874355 L69.649484,11.3561219 L69.3609654,11.065045 L69.4566321,10.9688675 L71.9991383,13.5351278 L70.7342123,15.0709148 L70.5702123,14.9055302 C70.7397802,14.7437077 70.8931506,14.5401574 71.0308296,14.2948793 C71.1528173,14.0811515 71.2327926,13.8714947 71.2707556,13.6654 C71.318842,13.4094355 71.3006198,13.1667018 71.2160889,12.9366899 L70.1470519,11.8578734 L68.1836074,13.8241692 L68.9631136,14.6114 L69.614558,13.9590213 L69.8676444,14.2144769 L68.4721259,15.6118497 L68.2190395,15.3563941 L68.870484,14.7040154 L68.0904716,13.9167846 L66.1214593,15.889187 L67.1899901,16.9680036 Z"
              id="Fill-23"
            />
            <path
              d="M71.9425481,22.9430698 C72.1490667,23.0748686 72.3824123,23.143058 72.6435975,23.1476379 C72.8516346,23.1532355 73.0723259,23.1181231 73.3051654,23.0428095 C73.5709062,22.9603716 73.8002025,22.8529988 73.9925481,22.7201822 L74.1190914,22.9160994 L72.3611531,23.8386911 L70.3961901,20.8032473 L70.5090667,20.7289515 L70.7322889,21.0739692 L75.4948691,17.9576142 L75.2711407,17.6125964 L75.3845235,17.5388095 L76.206042,18.8074367 L76.0926593,18.8817325 L75.8790543,18.5509633 L71.1164741,21.6673183 L71.9425481,22.9430698 Z"
              id="Fill-25"
            />
            <polygon
              id="Fill-27"
              points="5.2342321 54.4108769 3.1189358 55.1421314 3.45857778 56.1364746 3.0258 56.2855751 2.68615802 55.2922497 0.145676543 56.1705692 -0.000101234568 55.7436225 5.51262716 53.837374 6.1195284 55.6108059 5.69484938 55.7573621"
            />
            <polygon
              id="Fill-30"
              points="2.38255556 61.6260734 7.59360494 58.9997657 7.79506173 59.4033041 2.58350617 62.0301207"
            />
            <path
              d="M8.09825926,65.1745148 C8.3397037,65.5241124 8.80841975,65.6096036 9.15616049,65.3673787 L9.74534568,64.9572249 C10.0935926,64.7144911 10.1786296,64.2432722 9.93769136,63.8931657 L9.62740741,63.4433195 L7.78848148,64.7251775 L8.09825926,65.1745148 Z M6.20264198,67.9743491 L5.94702469,67.6028698 L7.53741975,66.4950473 C7.88516049,66.2533314 7.97019753,65.7816036 7.72925926,65.4320059 L7.41897531,64.9816509 L5.20345679,66.525071 L4.94783951,66.1541006 L9.74079012,62.814858 L10.3066914,63.6361834 C10.6858148,64.1857692 10.548642,64.9470473 10.0014691,65.3281953 L9.41228395,65.738858 C9.07820988,65.9709053 8.6621358,66.0080533 8.31237037,65.8818521 C8.29971605,66.2599467 8.12660494,66.6339704 7.79303704,66.8665266 L6.20264198,67.9743491 Z"
              id="Fill-32"
            />
            <path
              d="M11.9252296,69.1404379 C11.9252296,69.1404379 11.9692667,68.7358817 12.2684148,68.4468402 L12.5478222,68.1756095 C12.9962914,67.7415385 13.7049333,67.7552781 14.1361926,68.2066509 C14.567958,68.656497 14.5542914,69.3689231 14.1063284,69.8029941 L13.5834519,70.3088166 L13.2341926,70.0192663 L13.7945259,69.4773136 C14.0622914,69.2182959 14.069884,68.7882959 13.8127481,68.5191006 C13.5551062,68.2499053 13.1273901,68.2417633 12.8596247,68.5012899 L12.5797111,68.7720118 C12.3995136,68.9470651 12.3762296,69.1862367 12.3762296,69.1862367 L12.1525012,71.3194438 C12.1525012,71.3194438 12.107958,71.7367219 11.803242,72.0318698 L11.3983037,72.4231953 C10.9503407,72.8567574 10.2416988,72.8430178 9.80993333,72.3931716 C9.37867407,71.9423077 9.39234074,71.2293728 9.84080988,70.7958107 L10.4568222,70.1999172 L10.8055753,70.4889586 L10.1521062,71.122 C9.88434074,71.3805089 9.87624198,71.8105089 10.133884,72.0797041 C10.3915259,72.3488994 10.819242,72.3570414 11.0870074,72.0980237 L11.4914395,71.7061893 C11.6721432,71.5311361 11.7015012,71.2741538 11.7015012,71.2741538 L11.9252296,69.1404379 Z"
              id="Fill-34"
            />
            <polygon
              id="Fill-36"
              points="18.8245173 73.0236178 18.1862333 72.5330615 14.9178753 76.8330615 14.553937 76.5536888 17.8228012 72.2531799 17.1774309 71.7580438 17.4497519 71.3992864 19.0978506 72.6643515"
            />
            <path
              d="M26.7020852,79.0192935 L27.0483074,78.1669266 C27.1890235,77.8219089 27.0240111,77.4254947 26.6798136,77.2845361 C26.3361222,77.1430686 25.9423198,77.309471 25.8016037,77.6549976 L24.3802704,81.1504651 C24.2395543,81.4959917 24.4050728,81.8924059 24.7492704,82.0333645 C25.0924556,82.1753408 25.4867642,82.0089385 25.6274802,81.662903 L25.9281469,80.9235065 L26.3437148,81.0944888 L26.0430481,81.8333763 C25.8076778,82.4124769 25.1542086,82.6882876 24.5791963,82.4516604 C24.0031716,82.2150331 23.7293321,81.5580746 23.9647025,80.9805006 L25.3860358,77.4840154 C25.6209,76.9054237 26.273863,76.6301219 26.8498877,76.8667491 C27.4254062,77.1028675 27.6997519,77.759826 27.4638753,78.3384178 L27.1373938,79.1419325 L26.7020852,79.0192935 Z"
              id="Fill-38"
            />
            <polygon
              id="Fill-40"
              points="31.9919457 84.1942544 31.8871679 84.6334142 30.080637 84.2003609 31.433637 78.4963728 31.8704642 78.6006923 30.6217358 83.8655207"
            />
            <path
              d="M36.8965074,83.4202544 L37.9387173,83.5062544 L37.7068901,80.0703254 L37.6896802,80.0687988 L36.8965074,83.4202544 Z M38.529421,85.5163136 L38.081458,85.4791657 L37.9711123,83.9616982 L36.7912235,83.8650118 L36.4450012,85.3448225 L35.9975444,85.3076746 L37.3606679,79.5360059 L38.1184086,79.5980888 L38.529421,85.5163136 Z"
              id="Fill-42"
            />
            <path
              d="M42.8002543,81.8096627 C42.8002543,81.8096627 42.518316,81.517568 42.4874395,81.1018166 L42.4585877,80.7125266 C42.4115136,80.088645 42.8736494,79.5487278 43.4942173,79.5019112 C44.114279,79.4550947 44.6513284,79.9196982 44.6978963,80.5435799 L44.7520568,81.2702544 L44.3081432,81.3562544 L44.2499333,80.5771657 C44.2220938,80.2046686 43.897637,79.9242781 43.5276247,79.9522663 C43.1571062,79.9797456 42.8787111,80.3064438 42.9060444,80.678432 L42.9354025,81.0677219 C42.9541309,81.3196154 43.1226864,81.4895799 43.1226864,81.4895799 L44.6143778,83.0228225 C44.6143778,83.0228225 44.9054272,83.3230592 44.9368099,83.7474615 L44.9793284,84.3097692 C45.0253901,84.9336509 44.5632543,85.473568 43.9436988,85.5198757 C43.3231309,85.5672012 42.7865877,85.1031065 42.7395136,84.4792249 L42.6757358,83.6222781 L43.1196494,83.5362781 L43.1874765,84.4446213 C43.215316,84.8181361 43.5392667,85.0980178 43.9097852,85.0705385 C44.2803037,85.0420414 44.5592049,84.7158521 44.5308593,84.3438639 L44.4893531,83.7810473 C44.4706247,83.5296627 44.2919457,83.3434142 44.2919457,83.3434142 L42.8002543,81.8096627 Z"
              id="Fill-44"
            />
            <path
              d="M48.9094568,80.9919503 C48.9094568,80.9919503 48.5855062,80.7476899 48.4898395,80.342116 L48.4002469,79.9619858 C48.2564938,79.3533704 48.6285309,78.7472994 49.2339136,78.6027787 C49.8387901,78.4587669 50.441642,78.8322817 50.5853951,79.440897 L50.7529383,80.1502698 L50.3277531,80.3054769 L50.1485679,79.5452166 C50.0625185,79.1818793 49.6985802,78.9564473 49.3371728,79.0419385 C48.9757654,79.1279385 48.7515309,79.494329 48.8370741,79.8576663 L48.9266667,80.2383053 C48.9848765,80.4830746 49.1782346,80.6240331 49.1782346,80.6240331 L50.8911235,81.902329 C50.8911235,81.902329 51.2251975,82.1532047 51.3233951,82.5669207 L51.4524691,83.1165065 C51.5967284,83.724613 51.2246914,84.3311929 50.6193086,84.4757136 C50.0144321,84.6197254 49.4110741,84.2467195 49.2678272,83.6375953 L49.0699136,82.8010036 L49.4950988,82.6457964 L49.7046543,83.5332757 C49.7901975,83.896613 50.1541358,84.1225538 50.5155432,84.036045 C50.8769506,83.9495361 51.1016914,83.5841633 51.015642,83.220826 L50.8860617,82.6717491 C50.828358,82.426471 50.6228519,82.2702462 50.6228519,82.2702462 L48.9094568,80.9919503 Z"
              id="Fill-47"
            />
            <path
              d="M59.9318259,75.7222876 C59.7263198,75.3508083 59.2682333,75.2185006 58.898221,75.425613 L58.3844556,75.7116012 L60.7776407,80.0477314 L61.2919123,79.7612343 C61.6614185,79.5551396 61.7930235,79.0946071 61.5875173,78.7226189 L59.9318259,75.7222876 Z M61.9803074,78.5032935 C62.3032457,79.0885006 62.0911593,79.831968 61.5095667,80.1561219 L60.6030111,80.6624533 L57.7735049,75.5355302 L58.6800605,75.0297077 C59.2616531,74.705045 60.0016778,74.9187728 60.324616,75.503471 L61.9803074,78.5032935 Z"
              id="Fill-49"
            />
            <path
              d="M65.6022778,75.1411006 L66.4243025,74.4912663 L63.9308951,72.1300828 L63.9172284,72.1412781 L65.6022778,75.1411006 Z M68.2161543,75.561432 L67.8633519,75.8402959 L66.7558457,74.803716 L65.8249938,75.5385325 L66.5721049,76.859574 L66.2187963,77.1389467 L63.3158951,71.9758935 L63.9136852,71.5036568 L68.2161543,75.561432 Z"
              id="Fill-51"
            />
            <polygon
              id="Fill-53"
              points="68.6531333 67.6212402 68.1008988 68.207974 72.0120963 71.9237846 71.6972568 72.2576071 67.7870716 68.5423053 67.2292691 69.1356544 66.9027877 68.8252402 68.3266519 67.310826"
            />
            <polygon
              id="Fill-55"
              points="75.3401827 67.8742024 70.6089852 64.4464154 70.8716889 64.079516 75.6033926 67.5078118"
            />
            <polygon
              id="Fill-57"
              points="72.9840494 60.7703479 73.2361235 60.2843716 77.7942099 61.1189278 77.8023086 61.1036615 73.8799753 59.0447503 74.0880123 58.644774 79.2585679 61.3591172 79.0505309 61.7590935 74.2342963 60.897058 74.2261975 60.9123243 78.362642 63.0842059 78.1546049 63.4841822"
            />
            <path
              d="M78.6090469,54.9527787 L78.9598247,53.8800686 L81.8809481,54.8459148 L81.6880963,55.184826 L81.4992938,55.1217254 C81.6015407,55.3664947 81.6192568,55.6458675 81.5301704,55.9186249 C81.3358,56.511974 80.7035901,56.8335834 80.1128864,56.6381751 L76.5428494,55.4580923 C75.9521457,55.2621751 75.6332568,54.6270982 75.827121,54.0327314 C76.0214914,53.4393822 76.6542074,53.1177728 77.2449111,53.3136899 L77.9014173,53.530471 L77.8103062,53.9757373 L77.1041951,53.7421633 C76.7518988,53.6256308 76.3702444,53.8190036 76.2538247,54.1741988 C76.1379111,54.5288852 76.330763,54.9125775 76.6835654,55.0291101 L80.2530963,56.2091929 C80.6053926,56.3257254 80.9870469,56.1323527 81.1034667,55.7766485 C81.2193802,55.422471 81.0265284,55.0387787 80.6737259,54.9217373 L79.2463185,54.4500095 L79.0357506,55.0932284 L78.6090469,54.9527787 Z"
              id="Fill-59"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)};

const Top = glamorous.div({
  paddingTop: 32,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [dimensions.SCREEN_MAX_LG]: {
    flexDirection: "column"
  }
});

const Item = glamorous.li({
  display: "inline-block",
  padding: "0 10px",
  textTransform: "uppercase",
  },
  (({linkColor}) => ({
    color: linkColor
  }))
);

const Separator = glamorous.li({
  display: "inline-block",
  ...textColor.PURPLE_GRAY,
  "::before": {
    content: "|",
  }

  },
  (({fontColor}) => ({
    color: fontColor
  }))
);

const LeftItems = glamorous.ul({
  padding: "0 50px 0 0",
  textAlign: "right",
  order: 1,
  flex: 1,
  [dimensions.SCREEN_MAX_LG]: {
    order: 2,
    padding: 4,
    textAlign: "center",
    margin: 0,
    flexDirection: "column",
    flex: "none",
  }
});

const Logo = glamorous.div({
  order: 2,
  [dimensions.SCREEN_MAX_LG]: {
    order: 1,
    padding: 0,
    textAlign: "center"
  }
});

const RightItems = glamorous.ul({
  order: 3,
  flex: 1,
  padding: "0 0 0 50px",
  [dimensions.SCREEN_MAX_LG]: {
    padding: 4,
    margin: 0,
    textAlign: "center",
    flex: "none"
  }
});

const Bottom = glamorous.div({
  padding: "46px 0 24px 0",
  display: "flex",
  justifyContent: "center",
  [dimensions.SCREEN_MAX_LG]: {
    padding: "27px 0 24px 0",
    flexDirection: "column"
  }
},
  (({fontColor}) => ({
    color: fontColor
    }
  )
 ));

const CopyRight = glamorous.div({
  paddingLeft: 88,
  order: 1,
  flex: 1,
  [dimensions.SCREEN_MAX_LG]: {
    order: 3,
    padding: 0,
    textAlign: "center",
  },
  [dimensions.SCREEN_MIN_LG]: {
    lineHeight: "80px",
  },
});

const MemberContainer = glamorous.div({
  order: 2,
  textAlign: "center",
  [dimensions.SCREEN_MAX_LG]: {
    justifyContent: "center",
    paddingBottom: 12,
    display: "flex",
  }
});

const Member = glamorous.div({
  textAlign: "center",
  [dimensions.SCREEN_MAX_LG]: {
    maxWidth: 300
  },
});

const SocialIcons = glamorous.div({
  display: "flex",
  alignItems: "center",
  paddingRight: 88,
  justifyContent: "flex-end",
  order: 3,
  flex: 1,
  [dimensions.SCREEN_MAX_LG]: {
    order: 1,
    padding: "0 0 20px 0",
    justifyContent: "center"
  }
});

const Icon = glamorous.a({
  paddingLeft: 18,
  display: "flex",
  [dimensions.SCREEN_MAX_LG]: {
    ":first-of-type": {
      paddingLeft: 0
    }
  }
});

const MTFooter = props => {
  const { contentColor, backgroundColor } = props;
  const logoColor = contentColor ? contentColor : "white";
  const linkColor = contentColor ? contentColor : textColor.LIGHT_PURPLE.color;
  const colorScheme = contentColor ? contentColor : color.PURPLE_GREY;
  const footerColor = backgroundColor ? backgroundColor : color.BRAND_1_DARK;
  return (
    <Footer minHeight={212} background={footerColor} marginTop={10}>
      <Container>
      <Top>
        <LeftItems>
          <Item linkColor={linkColor}>
            <a href="https://www.misstravel.com/faq/guidelines">
              Rules &amp; Policies
            </a>
          </Item>
          <Separator fontColor={colorScheme} />
          <Item linkColor={linkColor}>
            <a href="https://misstravel.com/faq">Faq/Help</a>
          </Item>
        </LeftItems>
        <Logo>{MTLogo(logoColor)}</Logo>
        <RightItems>
          <Item linkColor={linkColor}>
            <a href="https://misstravel.com/terms">Terms</a>
          </Item>
          <Separator fontColor={colorScheme} />
          <Item linkColor={linkColor}>
            <a href="https://misstravel.com/privacy">Privacy</a>
          </Item>
          <Separator fontColor={colorScheme} />
          <Item linkColor={linkColor}>
            <Link to="/gdpr">GDPR</Link>
          </Item>
        </RightItems>
      </Top>
      <Bottom fontColor={colorScheme}>
        <CopyRight paddingLeft={88} justifyContent="flex-start">
          © MissTravel.com 2010-{new Date().getFullYear()}
        </CopyRight>
        <MemberContainer>
          <Member>W8Tech Cyprus Limited
            <br />Irakleous 2, Flat/Office 101
            <br />2320 Nicosia, Cyprus
          </Member>
        </MemberContainer>
        <SocialIcons>
          <Span display="flex">
            <Icon target="_blank" href={SOCIAL_LINKS.facebook}>{facebook(colorScheme)}</Icon>
            <Icon target="_blank" href={SOCIAL_LINKS.instagram}>{instagram(colorScheme)}</Icon>
            <Icon target="_blank" href={SOCIAL_LINKS.twitter}>{twitter(colorScheme)}</Icon>
            <Icon target="_blank" href={SOCIAL_LINKS.youtube}>{youtube(colorScheme)}</Icon>
          </Span>
        </SocialIcons>
      </Bottom>
      </Container>
    </Footer>
  );
};

export default MTFooter;


// WEBPACK FOOTER //
// ./src/components/blocks/MTFooter.jsx